import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Localization } from '../services/localization.service'; // <-- fix path

@Pipe({ name: 'localizationDate' })
export class LocalizationDatePipe implements PipeTransform {

  private datePipe: DatePipe;

  constructor(
    private localization: Localization,
    @Inject(LOCALE_ID) locale: string,
  ) {
    this.datePipe = new DatePipe(locale);
  }

  transform(value: Date | string | number | null | undefined): string | null {
    if (value == null) {
      return null;
    }
    const format = this.localization.get('portegoJS.dateFormat');
    return this.datePipe.transform(value, format);
  }
}